import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { URL_PATHS } from 'site-modules/shared/constants/appraisal/paths';
import { Link } from 'site-modules/shared/components/link/link';
import { FeatureFlag } from 'site-modules/shared/components/feature-flag/feature-flag';
import { getStaticImageUrl } from 'client/utils/image-helpers';

import './appraisals-promo-unit.scss';

const CTA_TEXT = "See my car's value";

export function AppraisalsPromoUnit({ className, isMobile }) {
  return (
    <FeatureFlag name="EMO-3092-appraisalsHpPromo">
      <div
        className={classnames('appraisals-banner pos-r mx-1_75 mx-lg-0 bg-cool-gray-100', className)}
        data-tracking-parent="appraisals-promotion"
      >
        <Row
          tag={Link}
          to={URL_PATHS.APPRAISAL_LANDING}
          rel="nofollow"
          data-tracking-id="appraise_car"
          data-tracking-value={CTA_TEXT}
          className="pos-r no-focus text-decoration-none py-0_75 py-lg-0 mx-0 align-items-center justify-content-center h-100"
        >
          <Col
            xs={12}
            lg="auto"
            className="d-flex align-items-center me-lg-3_5 mb-0_75 mb-lg-0 ps-0_75 ps-lg-0_5 pe-0_75 pe-lg-1"
          >
            <img
              src={getStaticImageUrl('/img/appraisal/banner-car-arrow.svg')}
              alt=""
              width={isMobile ? 53 : 117}
              height={isMobile ? 41 : 90}
              className="me-0_5 me-lg-1_25"
            />
            <div className="d-inline-block">
              <div className="header text-cool-gray-10 size-14 fw-bold mb-md-0_5">Used car values are trending up</div>
              <div className="subheader text-cool-gray-30 size-12 fw-medium">Find out what your car is worth</div>
            </div>
          </Col>
          <Col xs={12} lg="auto" className="px-0_75 px-lg-0_5">
            <div className="pos-r btn text-white bg-blue-50 size-16 fw-medium border-0 p-0 d-flex align-items-center justify-content-center">
              {CTA_TEXT}
            </div>
          </Col>
        </Row>
      </div>
    </FeatureFlag>
  );
}

AppraisalsPromoUnit.propTypes = {
  className: PropTypes.string,
  isMobile: PropTypes.bool,
};

AppraisalsPromoUnit.defaultProps = {
  className: null,
  isMobile: false,
};
